module.exports = __webpack_public_path__ + "static/img/touxiang1.9db529a6.png";